// 4Winners Merch — Client Intake (Shopify section, progress + validation)
(function () {
  var root = document.querySelector('.fw-intake');
  if (!root) return;
  var form = root.querySelector('.fw-intake__form');
  if (!form) return;

  var fill = root.querySelector('.fw-intake__fill');
  var pctEl = root.querySelector('.fw-intake__pct span');
  var navItems = root.querySelectorAll('.fw-intake__nav li');
  var sections = root.querySelectorAll('.fw-intake__sec');
  var submitBtn = form.querySelector('.fw-intake__btn');
  var statusEl = form.querySelector('.fw-intake__status');

  var allFieldNames = [];
  form.querySelectorAll('input[name], textarea[name]').forEach(function (el) {
    if (!el.name.startsWith('contact[')) return;
    if (el.type === 'hidden' || el.type === 'submit') return;
    allFieldNames.push(el);
  });

  function updateProgress() {
    var filled = 0;
    allFieldNames.forEach(function (el) {
      if ((el.value || '').trim().length > 0) filled++;
    });
    var total = allFieldNames.length || 1;
    var pct = Math.round((filled / total) * 100);
    if (fill) fill.style.width = pct + '%';
    if (pctEl) pctEl.textContent = pct + '%';
    sections.forEach(function (sec, idx) {
      var fields = sec.querySelectorAll('input[name], textarea[name]');
      var need = 0, have = 0;
      fields.forEach(function (el) {
        if (el.type === 'hidden' || el.type === 'submit') return;
        need++;
        if ((el.value || '').trim().length > 0) have++;
      });
      var li = navItems[idx];
      if (!li) return;
      li.classList.toggle('is-done', need > 0 && have === need);
    });
  }

  form.addEventListener('input', updateProgress);
  form.addEventListener('change', updateProgress);

  navItems.forEach(function (li, idx) {
    li.addEventListener('click', function () {
      var sec = sections[idx];
      if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (ent) {
        if (ent.isIntersecting) {
          var idx = Array.prototype.indexOf.call(sections, ent.target);
          navItems.forEach(function (li, i) { li.classList.toggle('is-current', i === idx); });
        }
      });
    }, { threshold: 0.3 });
    sections.forEach(function (sec) { io.observe(sec); });
  }

  form.addEventListener('submit', function (e) {
    var firstError = null;
    form.querySelectorAll('.fw-intake__field[data-required="true"]').forEach(function (fld) {
      var input = fld.querySelector('input, textarea');
      var empty = input && (input.value || '').trim().length === 0;
      fld.classList.toggle('has-error', empty);
      if (input) input.classList.toggle('has-error', empty);
      if (empty && !firstError) firstError = fld;
    });
    if (firstError) {
      e.preventDefault();
      if (statusEl) {
        statusEl.className = 'fw-intake__status is-error';
        statusEl.textContent = 'Please complete the required fields marked in red before submitting.';
      }
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
    }
  });

  updateProgress();
})();
